var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"completo"},[_c('canvas',{ref:"myCanvasPorcentaje"}),_c('canvas',{ref:"myCanvasLabels",staticClass:"canvas-labels"})])
}
var staticRenderFns = []

export { render, staticRenderFns }